import { anyPass, find, prop, propEq, test } from 'ramda';

import { type AuthenticationStatus, type SSOMethod } from '@accounts/types/authentication';

const onboardingPagePathTest = /\/rooms\/.+?\/members\/.+?\/onboard\/.+?/;

const accountsPagePathTests = [
    /^\/$/,
    /^\/password\/reset/,
    /^\/2fa\/reset/,
    /^\/material-upload/,
    /^\/upload-debug/,
    onboardingPagePathTest
];
const notAuthenticatedPagePathTests = [
    /^\/instruction\/sign-up/,
    /^\/instruction\/pending-invitation/,
    /^\/email-feedback/
];
const neutralPagePathTests = [
    /^\/$/,
    /^\/password\/reset/,
    /^\/2fa\/reset/,
    /^\/material-upload/,
    onboardingPagePathTest
];

/**
 * Path that is for Accounts layout (has different base layout interface, different redux store, etc).
 */
export const isAccountsPagePath: (path: string) => boolean = anyPass(
    accountsPagePathTests.map((path) => test(path))
);

/**
 * Path that should be only for users who are not authenticated.
 */
export const isNotAuthenticatedPagePath: (path: string) => boolean = anyPass(
    notAuthenticatedPagePathTests.map((path) => test(path))
);

/**
 * Path that can be visited by anyone, authenticated or not.
 */
export const isNeutralPagePath: (path: string) => boolean = anyPass(
    neutralPagePathTests.map((path) => test(path))
);

/**
 * Onboarding path. This is needed specifically for Onboarding for SSO case
 */
export const isOnboardingPagePath = test(onboardingPagePathTest);

export const getFirstAvailableSSOPrimaryProof = (
    authStatus: AuthenticationStatus
): SSOMethod | undefined => find(propEq('sso', 'type'), prop('acceptPrimary', authStatus));
